import React from 'react';
import {useRef} from 'react';
import {Center, Text} from '@mantine/core';
import '@mantine/core/styles.css';
import HeroContent from "./components/HeroContent";
import ContactUs from "./components/Contact";
import About from "./components/About";
import FeatureCards from "./components/FeatureCards";
import HeroImage from "./components/HeroImage";
import FeaturesAsymmetrical from "./components/FeaturesAsymmentrical";
import classes from './CopyrightWrapper.module.css';
import { Link } from 'react-router-dom';
import { Anchor } from '@mantine/core';

function App() {
    const ContactUsSection = useRef<HTMLDivElement | null>(null);
    function scrollToContactUsSection() {
        ContactUsSection.current?.scrollIntoView({behavior: 'smooth'});
    }
    return (
        <>
            <HeroContent scrollToSection={scrollToContactUsSection}/>
            <About/>
            <FeatureCards/>
            <HeroImage/>
            <FeaturesAsymmetrical/>
            <div ref={ContactUsSection}>
                <ContactUs/>
            </div>
            <div className={classes.wrapper}>
                <Center>
                    <Text c="white" size="sm">
                        © IC Trading 2024, all rights reserved. By using this website you agree to our{' '}
                        <Anchor
                            href="/#/terms"
                            target="_blank"
                            rel="noopener noreferrer"
                            c="yellow.9"
                        >
                            Terms and Conditions
                        </Anchor>.
                    </Text>
                </Center>
            </div>

        </>
);
}

export default App;
